import { storage } from "../firebase";
export const deleteFile = (url)=>{
    return storage.refFromURL(url).delete();
}
